import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import DrawerAppBar from './menu'; // Import your navigation component
import Home from './pages/home'; // Import your Home component
import { Box, Toolbar } from '@mui/material';
import About from './pages/about';
import Footer from './footer';
import ServicePage from './pages/service';
import CustomerSoftDev from './pages/service/customersoftwaredevelopment';
import Softwareconsultancy from './pages/service/softwareconsultancy';
import Webdev from './pages/service/dataanalytics.js';
import Softwaretesting from './pages/service/blockchain.js';
import Bps from './pages/service/bps';
import Security from './pages/service/security.js';
import Rpa from './pages/service/rpa';
import GetInTouch from './pages/getintouch.js';
import Crm from './pages/service/crm.js';
import CareerPage from './pages/career/index.js';
import Technology from './pages/technology/index.js';
import Home1 from './pages/home1/index.js';
import ServiceTech from './component/servicetech/index.js';
import Ai from './pages/service/ai.js';
import BlockChain from './pages/service/blockchain.js';
import DataAnalytics from './pages/service/dataanalytics.js';
import TermsOfService from './pages/agreement/termanscondition.js';
// import Offering from './pages/offering'; // Import your Offering component
// import About from './pages/about'; // Import your About component
// import Contact from './pages/contact'; // Import your Contact component

const App = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <Box sx={{ display: 'flex' }}>
      <DrawerAppBar /> {/* Include your navigation bar */}
      <Box component="main" sx={{ flexGrow: 1 }}> {/* Use Box for main content */}
        <Toolbar /> {/* Add Toolbar for spacing */}
        <Routes>
          <Route path="/" element={<Home1 />} />
          <Route path="/home1" element={<Home1 />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path="/career" element={<CareerPage />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/offering/artificialintelligence" element={<Ai />} />
          <Route path="/offering/businessprocessservices" element={<Bps />} />
          <Route path="/offering/CustomerSoftDev" element={<CustomerSoftDev />} />
          <Route path="/offering/consultancy" element={<Softwareconsultancy />} />
          <Route path="/offering/BlockChain" element={<BlockChain />} />
          <Route path="/offering/dataanalytics" element={<DataAnalytics />} />
          <Route path="/offering/rpa" element={<Rpa />} />
          
          <Route path="/offering/security" element={<Security />} />
          <Route path="/offering/service" element={<ServiceTech />} />
          <Route path="/reachout" element={<GetInTouch />} />
          <Route path="/termsandcondition" element={<TermsOfService />} />
          <Route path="/offering/crmdevelopment" element={<CareerPage />} />
        </Routes>
      </Box>
      {/* <Footer/> */}
    </Box>
  );
};

export default App;
